import { useLayoutEffect } from "react";
import { useSetStyleEditorView } from "../../../hooks/style";

export function MapSettings() {
  const setStyleEditorView = useSetStyleEditorView();

  useLayoutEffect(() => {
    setStyleEditorView("settings");
  }, [setStyleEditorView]);

  return null;
}
